export const TERMS_SECTIONS = [
  {
    title: "1. Танилцуулга",
    content: [
      {
        text: (
          <p>
            {" "}
            MMusic Distribution нь хөгжмийн урлагийн бүтээлийг хууль ёсоор эдийн
            засгийн эргэлтэд оруулах, уран бүтээлчдийг дэмжих зорилгоор хөгжмийн
            урлагийн бүтээлийг түгээх үйл ажиллагаа явуулдаг бөгөөд та энэхүү
            Уран бүтээлчийн үйлчилгээний нөхцөл (“
            <strong className="font-semibold">Үйлчилгээний нөхцөл</strong>”)-тэй
            танилцаж “хүлээн зөвшөөрч байна” сонголтыг хийснээр Үйлчилгээний
            нөхцөл, өөрийн хүлээн зөвшөөрсөн Тусгай нөхцөл, MMusic-ын Оюуны
            өмчийн бодлого, Нууцлалын бодлого, Гомдол шийдвэрлэх журам болон
            бусад холбогдох журамд заасны дагуу Уран бүтээлчдэд зориулсан
            үйлчилгээг авна.{" "}
          </p>
        ),
      },
      {
        text: (
          <p>
            Үйлчилгээний нөхцөлийг хүлээн зөвшөөрч, 3 дугаар зүйлд заасны дагуу
            өөрийн MMusic профайлыг үүсгэж, Тусгай нөхцөлөөс сонгон, Уран бүтээл
            байршуулсан этгээдийг энэхүү үйлчилгээний нөхцөлд {""}
            <strong className="font-semibold">
              “Уран бүтээлч”, “Үйлчилгээ авагч”, “та” {""}
            </strong>
            зэргээр тодорхойлно.
          </p>
        ),
      },
      {
        text: (
          <p>
            Үйлчилгээний нөхцөлд М Мюзик ХХК-ийг {""}
            <strong className="font-semibold">
              “MMusic”, “Үйлчилгээ үзүүлэгч”, “бид”, “манай” {""}
            </strong>
            зэргээр тодорхойлно.
          </p>
        ),
      },
      {
        text: "MMusic дэх өөрийн профайлд таны байршуулсан хөгжмийн урлагийн үгтэй болон үггүй бүтээл тус бүрийг энэхүү Үйлчилгээний нөхцөлд “Уран бүтээл” гэж тодорхойлно. ",
      },
      {
        text: "Энэхүү Үйлчилгээний нөхцөл болон Тусгай нөхцөл нь хамтдаа Уран бүтээлч болон Үйлчилгээ үзүүлэгчийн хооронд Монгол Улсын хууль тогтоомжийн дагуу цахимаар байгуулагдсан нэг бүхэл гэрээнд тооцогдоно. ",
      },
    ],
  },
  {
    title: "2. Уран бүтээлчдэд үзүүлэх үйлчилгээ",
    content: [
      {
        subtitle: "Үйлчилгээнүүд",
        text: "Уран бүтээл, түүний хуулбарыг MMusic дижитал үйлчилгээгээр дамжуулан аливаа хэлбэрээр, хэрэглэгч өөрийн сонгосон цаг, газраас хүртэх боломжтой байдлаар түгээх, Уран бүтээлийн хуулбарыг худалдаалах, борлуулах, түрээслэх, ийнхүү ашигласны дагуу олсон орлогыг Тусгай нөхцөлд заасны дагуу Уран бүтээлчид шилжүүлэх үйлчилгээ",
      },
      {
        text: "Уран бүтээлийн сонсолт, борлуулалтын талаарх мэдээллийг Уран бүтээлчид харуулах үйлчилгээ.",
      },
      {
        text: "Уран бүтээлийг кино, телевизийн нэвтрүүлэг, зар сурталчилгаа, видео тоглоом, дижитал медиа зэрэг дүрс, дуу хосолсон төслүүдэд санал болгох үйлчилгээ.",
      },
      {
        text: "Өргөн нэвтрүүлгийн телевиз, радио сувгууд зэрэгт Уран бүтээлийг санал болгох үйлчилгээ.",
      },
      {
        text: "Уран бүтээлч нь MMusic-ын Уран бүтээлчдэд үзүүлэх үйлчилгээнээс өөрөө сонгох боломжтой бөгөөд сонгосон үйлчилгээтэй холбоотой Уран бүтээлийн зохиогчийн эрхийн онцгой эрхийг MMusic-д олгоно. Уран бүтээлч нь MMusic-ын Уран бүтээлчдэд үзүүлэх үйлчилгээнээс сонгож, тухайн үйлчилгээг үзүүлэхэд шаардлагатай Уран бүтээлийн зохиогчийн эрхийн онцгой эрхийг MMusic-д олгосон, орлого хуваарилах нөхцөл болон бусад шаардлагатай нөхцөлийг сонгон нь Тусгай нөхцөл гэж үзнэ. ",
      },
      {
        text: "Уран бүтээлч нь Үйлчилгээнүүдтэй холбоотой санал, хүсэлтийг MMusic-д гаргах эрх нээлттэй байна. ",
      },
      {
        subtitle: "Үйлчилгээний нөхцөлийн өөрчлөлт",
        text: (
          <>
            <p className="pb-1">
              Бид Уран бүтээлчдэд үзүүлэх үйлчилгээг үргэлж сайжруулахыг
              эрмэлзэж ажиллах бөгөөд хэдий тийм боловч Бид:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Хууль тогтоомжийн өөрчлөлт, шинэчлэл, холбогдох эрх бүхий
                байгууллагын шаардлага, хэрэглэгчдээс хамаарах хүчин зүйл, болон
                бусад үндэслэл бүхий нөхцөл байдлын улмаас нэн яаралтай нөхцөл
                байдлаас бусад тохиолдолд танд урьдчилан мэдэгдсэний үндсэн дээр
                үйлчилгээг бүхэлд нь эсхүл хэсэгчлэн өөрчлөлт хийх, түр
                түдгэлзүүлэх, зогсоох эрхтэй;
              </li>
              <li>
                Программ хангамж, технологийн сайжруулалт, шинэчлэл, хөгжүүлэлт
                хийх, алдаа засахын тулд нэн яаралтайгаас бусад тохиолдолд танд
                урьдчилан мэдэгдсэний үндсэн дээр үйлчилгээний ажиллагааг бүхэлд
                нь эсхүл хэсэгчлэн тодорхой хугацаанд зогсоох эрхтэй;
              </li>
              <li>
                Хууль тогтоомжийн өөрчлөлт, шинэчлэл, холбогдох эрх бүхий
                байгууллагын шаардлага, нийгэм, эдийн засгийн нөхцөл байдал,
                программ хангамж, технологийн сайжруулалт, хөгжүүлэлт, өөрчлөлт
                болон бусад үндэслэл бүхий нөхцөл байдлын улмаас танд урьдчилан
                мэдэгдсэний үндсэн дээр Үйлчилгээний нөхцөл, Тусгай нөхцөл,
                MMusic-ын Оюуны өмчийн бодлого, Нууцлалын бодлого болон таны
                үйлчилгээ авахтай холбоотой бусад холбогдох журамд өөрчлөлт
                оруулах, шинэ журам бий болгох эрхтэй.
              </li>
            </ul>
          </>
        ),
      },
      {
        text: "Уран бүтээлчдэд үзүүлэх үйлчилгээнд өөрчлөлт оруулахдаа MMusic нь өөрсдийн цахим хаягуудаар нийтлэх, платформоор мэдэгдэл илгээх, бүртгэлтэй и-мэйл хаягаар мэдээлэл илгээх зэрэг боломжит арга хэрэгслээр өөрчлөлтийг мэдэгдэнэ.  ",
      },
      {
        text: "MMusic нь Тусгай нөхцөлд өөрчлөлт оруулах тохиолдолд заавал Уран бүтээлчид и-мэйлээр урьдчилан мэдэгдэх бөгөөд Тусгай нөхцөлд оруулсан өөрчлөлтийг Уран бүтээлч хүлээн зөвшөөрөхгүй талаараа MMusic-д мэдэгдсэнээр үйлчилгээг зогсоож болно. Уран бүтээлчдэд үзүүлэх үйлчилгээний өөрчлөлтүүдтэй холбоотой асуудлаар та манай Гомдол шийдвэрлэх журмын дагуу гомдол гаргах эрх нээлттэй. ",
      },
    ],
  },
  {
    title: "3. Уран бүтээлчийн MMusic ашиглалт",
    content: [
      {
        subtitle: "Уран бүтээлчийн хаяг үүсгэх",
        text: "Та MMusic-ын Уран бүтээлчдэд үзүүлэх үйлчилгээг авахын тулд MMusic-д уран бүтээлчийн бүртгэл үүсгэх шаардлагатай. Ийнхүү бүртгэл үүсгэхдээ та зарим хувийн мэдээллийг оруулах шаардлагатай бөгөөд эдгээр нь зөвхөн үйлчилгээ үзүүлэхтэй холбоотой зорилгоор ашиглагдана. Бүртгэл үүсгэхэд оруулсан мэдээллийн үнэн зөвийг та хариуцах бөгөөд өөрчлөлт орсон тухай бүр засах нь таны хариуцлагын асуудал байна. Таны нэвтрэх нэр, нууц үг зөвхөн таны хэрэгцээнд зориулагдсан бөгөөд тэдгээрийн нууцлал алдагдсантай холбоотой хариуцлагыг та хүлээнэ. Хэрэв таны нэвтрэх мэдээлэл алдагдсан гэж үзвэл манай munkhgerel@mmusic.mn хаягаар нэн даруй мэдэгдэнэ.",
      },
      {
        subtitle: "Тусгай нөхцөл сонгох",
        text: "Та уран бүтээлчийн хаягаар манай Уран бүтээлчдэд үзүүлэх үйлчилгээнээс сонгож, тухайн үйлчилгээ үзүүлэхтэй холбоотой бидэнд олгож буй онцгой эрх, эрхийн хугацаа, орлого хуваарилах нөхцөл, холбогдох мэдэгдэл баталгаа зэргийг агуулсан Тусгай нөхцөлийг хүлээн зөвшөөрсөн байна.",
      },
      {
        subtitle: "Уран бүтээл оруулах",
        text: "Та Уран бүтээлийг манай платформоор дамжуулан эсхүл манай холбогдох ажилтанд илгээх бөгөөд танд үйлчилгээ үзүүлэхэд шаардлагатай Уран бүтээлтэй холбоотой мэдээллийг бөглөж өгнө.",
      },
    ],
  },
  {
    title: "4. Уран бүтээл, түүний оюуны өмчийн асуудал",
    content: [
      {
        subtitle: "Уран бүтээлийн зохиогчийн эрх",
        text: "Уран бүтээл нь бүтээгдмэгц буюу туурвисан үеэс тус тусдаа зохиогчийн эрх үүсгэдэг (separately copyrightable) бүтээлүүдийн нийлбэр (үг, ая г.м) бөгөөд Монгол Улсын хэмжээнд уран бүтээлчид бүтээл туурвихдаа гэрээ хэлцэл бичгээр байгуулах соёл дөнгөж төлөвшиж байгаа, хамтын удирдлагын байгууллагын үйл ажиллагаа жигдрээгүй зэрэг шалтгаанаар MMusic-ын зүгээс Уран бүтээл, түүний бүрдэл хэсгийн зохиогчийн эрх эдлэх этгээдийн мэдээллийг нарийн баталгаажуулах боломжгүй байна. ",
      },
      {
        text: "Иймд уран бүтээлч нь Уран бүтээлийн хувьд Монгол Улсын Зохиогчийн эрхийн тухай хуульд заасан зохиогчийн эрх эдлэх эрхтэй этгээд мөн болохоо баталж байгаа бөгөөд ирээдүйд аливаа оюуны өмчийн маргаан үүссэн тохиолдолд үүнтэй холбоотой аливаа хариуцлагыг дангаар хүлээнэ.",
      },
      {
        subtitle: "Гуравдагч этгээдийн шаардлага",
        text: "Уран бүтээлтэй холбоотой гуравдагч этгээд оюуны өмчийн асуудлаар аливаа шаардлагыг MMusic-д хандан гаргах эрх нээлттэй. Хэдий тийм боловч энэхүү Үйлчилгээний нөхцөлийн дагуу Уран бүтээлч нь MMusic-д Уран бүтээлийн оюуны өмчтэй холбоотой асуудлаар шаардлага гаргах гуравдагч этгээд байхгүй талаарх баталгаа гаргасан тул гуравдагч этгээдийн ирүүлсэн шаардлагыг бид Уран бүтээлчид мэдэгдэх болно. Гуравдагч этгээдийн шаардлагыг MMusic нь үнэлж, үүнтэй холбоотой аливаа хохирол учирч болохоор байвал холбогдох эрх бүхий байгууллага тухайн асуудлыг шийдвэрлэх хүртэл эсхүл Уран бүтээлч болон гуравдагч этгээд нар тус асуудлаар нэгдсэн шийдэлд хүрэх хүртэл MMusic нь үйлчилгээг бүхэлд нь эсхүл хэсэгчлэн үзүүлэхээс татгалзах эрхтэй.",
      },
      {
        subtitle: "Уран бүтээлийн агуулга",
        text: "Уран бүтээл нь Уран бүтээлчийн бүтээлч үйл ажиллагааны үр дүн тул Уран бүтээлийн агуулгад MMusic урьдчилсан хяналт, хязгаарлалт тогтоохгүй боловч Уран бүтээл нь хууль тогтоомжоор тухайлан хориглосон агуулгыг багтаагаагүй байна.",
      },
      {
        subtitle: "Бусдын зохиогчийн эрх",
        text: "Уран бүтээл нь бусад этгээдийн оюуны өмчийн эрх (барааны тэмдэг, зохиогчийн эрх, патентаар хамгаалагдах эрх болон үүгээр хязгаарлагдахгүй)-д халдаагүй, зөрчөөгүй байна. Түүнчлэн, Уран бүтээл, түүний аль нэг эсхүл хэд хэдэн бүрдэл хэсэг нь public domain (зохиогчийн бүтээл ашиглах онцгой эрх дуусгавар болсон) байх тохиолдолд Уран бүтээлч нь Уран бүтээл, түүний бүрдэл хэсэг нь public domain болохыг баталгаажуулсан байх ёстой бөгөөд үүнийгээ нотлох үүрэгтэй.",
      },
      {
        text: "Уран бүтээлч нь Уран бүтээл, түүний бүрдэл хэсэг нь зохиогчийн эрх зөрчсөнтэй холбоотой аливаа маргаанаас MMusic-ыг ангид байлгана.",
      },
      {
        subtitle: "Уран бүтээлийн онцгой эрх шилжүүлэх",
        text: "Уран бүтээлч нь үйлчилгээ авахтай холбогдуулан Монгол Улсын Оюуны өмчийн тухай хууль, Зохиогчийн эрхийн тухай хууль болон холбогдох бусад хууль тогтоомжийн дагуу Уран бүтээлийн онцгой эрхүүдээс MMusic-д Тусгай нөхцөлөөс сонгох замаар олгоно. Энэхүү Үйлчилгээний нөхцөл болон Тусгай нөхцөл нь хамтдаа Оюуны өмчийн тухай хууль болон Зохиогчийн эрхийн тухай хуульд заасан цахимаар байгуулах лицензийн гэрээний шинжийг агуулна.",
      },
    ],
  },
  {
    title: "5.Орлого хуваарилах бодлого",
    content: [
      {
        subtitle: "Орлого хуваарилах зарчим",
        text: "Уран бүтээлчийн Уран бүтээлийн холбогдох онцгой эрхийг ашигласан, Уран бүтээл түгээсэн, бусад байдлаар үйлчилгээ үзүүлэх явцад олсон орлогоос Уран бүтээлчид хуваарилах, төлөх хувь хэмжээг Уран бүтээлийг түгээж олсон орлого, түгээхэд гарсан зардал, хэрэглэгчдийн тоо, үнийн бодлого, эдийн засгийн нөхцөл байдал зэргийг харгалзан MMusic тогтооно. Орлого хуваарилалт болон түүнийг Уран бүтээлчид шилжүүлэх журам, холбогдох татварын асуудал зэрэг нь Тусгай нөхцөлөөр тодорхойлогдоно.",
      },
      {
        subtitle: "Холбогдох төлбөрийг шударгаар төлөх",
        text: "Уран бүтээл нь бүтээгдмэгц тус тусдаа зохиогчийн эрх үүсгэдэг (separately copyrightable) бүтээлүүдийн нийлбэр (үг, ая г.м) болохын хувьд Уран бүтээлч нь MMusic-ын Уран бүтээлчдэд үзүүлэх үйлчилгээтэй холбоотой олсон өөрт ногдох орлогоос Уран бүтээлийн ая зохиогч, үг зохиогч, дуу бичлэг бүтээгч зэрэг Уран бүтээлийн бүрдэл хэсгийн хувьд зохиогчийн эрх эзэмшигч нарт холбогдох гэрээ, хэлцэл, тохиролцооны дагуу төлбөр (royalty)-ийг дангаар хариуцан шударгаар төлөх үүрэгтэй. Уг үүргээ биелүүлээгүйтэй холбогдох аливаа шаардлага, нэхэмжлэл, гомдол, хүсэлт, төлбөрийн шаардлага зэргээс MMusic-ыг ангид байлгана.",
      },
      {
        subtitle: "Уран бүтээл оруулах",
        text: "Та Уран бүтээлийг манай платформоор дамжуулан эсхүл манай холбогдох ажилтанд илгээх бөгөөд танд үйлчилгээ үзүүлэхэд шаардлагатай Уран бүтээлтэй холбоотой мэдээллийг бөглөж өгнө.",
      },
    ],
  },
  {
    title: "6. Мэдэгдэл баталгаа",
    content: [
      {
        subtitle: "Уран бүтээлийн эрхийг хадгалах.",
        text: (
          <p>
            Уран бүтээлч нь Үйлчилгээ үзүүлэгчийн өмнө (i)
            <strong className="font-semibold">
              {" "}
              Уран бүтээлийн эд хөрөнгийн онцгой эрхийг хууль ёсоор, дангаар
              эзэмшигч гэдгээ,
            </strong>{" "}
            (ii)
            <strong className="font-semibold">
              {" "}
              шаардлага гаргах эрх бүхий аливаа этгээдээс зохих зөвшөөрлийг
              авсан болохоо,
            </strong>{" "}
            (iii)
            <strong className="font-semibold">
              {" "}
              энэхүү Үйлчилгээний нөхцөлийг хүлээн зөвшөөрч үйлчилгээ авах,
              цаашлаад Тусгай нөхцөл хүлээн зөвшөөрөх, Үйлчилгээний нөхцөл болон
              Тусгай нөхцөлийн дагуу үүргээ биелүүлэх эрх бүхий этгээд мөн
              болохоо
            </strong>{" "}
            мэдэгдэж, баталж байна. Уран бүтээлч нь Уран бүтээлийн оюуны өмчийн
            эрхтэй холбоотой гуравдагч этгээдийн гомдол, шаардлага, хүсэлт,
            нэхэмжлэл зэргээс MMusic-ыг ангид байлгана.
          </p>
        ),
      },
      {
        text: "Үйлчилгээ үзүүлэх явцад аливаа гуравдагч этгээдээс MMusic-д оюуны өмчтэй холбоотой гомдол, шаардлага, хүсэлт, нэхэмжлэл зэргийг гаргасан тохиолдолд бид танд мэдэгдэх бөгөөд Монгол Улсын хууль тогтоомж, Оюуны өмчийн бодлогын хүрээнд оюуны өмчийн ноцтой зөрчил байна гэж үзсэн тохиолдолд бид тодорхой хугацаагаар Уран бүтээлийг нийтэлсэн, байршуулсан платформ болон хүлээлгэн өгсөн аливаа этгээдээс буцаан татаж болно.",
      },
      {
        subtitle: "Уран бүтээлийн агуулга.",
        text: "Уран бүтээлч нь Уран бүтээлийн агуулгатай холбоотой аливаа гомдол, нэхэмжлэл, шаардлага зэргээс MMusic-ыг ангид байлгана. Үйлчилгээ үзүүлэх явцад аливаа гуравдагч этгээдээс MMusic-д Уран бүтээлийн агуулгатай холбоотой асуудлаар гомдол, шаардлага, хүсэлт, нэхэмжлэл зэргийг гаргасан тохиолдолд бид танд мэдэгдэх бөгөөд Монгол Улсын хууль тогтоомж, Үйлчилгээ үзүүлэгчийн холбогдох бодлогын хүрээнд ноцтой зөрчил байна гэж үзсэн тохиолдолд бид тодорхой хугацаагаар Уран бүтээлийг нийтэлсэн, байршуулсан платформ болон хүлээлгэн өгсөн аливаа этгээдээс буцаан татаж болно.",
      },
      {
        subtitle:
          "Аливаа өөрчлөлт, эрх бүхий байгууллагын шийдвэрийн талаар мэдэгдэх.",
        text: "Уран бүтээлч нь Уран бүтээлийн эрхийн эзэмшилд гарсан, агуулгад гарсан, Уран бүтээлтэй холбоотой аливаа эрх бүхий байгууллагаас гарсан шийдвэр зэрэг бид үйлчилгээ үзүүлэхэд нөлөөлөх аливаа мэдээлэл, өөрчлөлт зэргийг MMusic-д тухай бүр мэдэгдэх үүрэгтэй. Ийнхүү мэдэгдээгүйгээс MMusic болон гуравдагч этгээдэд учирсан аливаа хохирлыг Уран бүтээлч хариуцна.",
      },
    ],
  },
  {
    title: "7. Хяналтын хүрээнээс гадуурх эрсдэл",
    content: [
      {
        subtitle: "Хяналтын хүрээнээс гадуурх эрсдэл.",
        text: "Уран бүтээлийг дижитал платформ, телевизийн сувгууд зэрэг бусад этгээдэд нийлүүлсэнтэй холбоотой тухайн этгээдүүдийн платформын үйл ажиллагааны хүрээ хязгаараас хамааран Уран бүтээлийг хууль бусаар хуулбарлах, бичиж авах зэрэг эрсдэл гарч болохыг Уран бүтээлч хүлээн зөвшөөрч байгаа болно. Ийм эрсдэл гарсан тохиолдолд MMusic-ын зүгээс тухайн зөрчлийг арилгах, зөрчил гаргасан этгээдтэй хариуцлага тооцохтой холбоотой өөрийн зүгээс боломжит хүчин чармайлтыг гаргаж Уран бүтээлчтэй хамтран ажиллана.",
      },
    ],
  },
  {
    title: "8. Хэрэглэгдэх хууль, маргаан шийдвэрлэх",
    content: [
      {
        text: (
          <p>
            Энэхүү Үйлчилгээний нөхцөлөөр зохицуулаагүй бусад асуудлыг Тусгай
            нөхцөл,{" "}
            <strong className="font-semibold">
              MMusic-ын Оюуны өмчийн бодлого, Нууцлалын бодлого, Гомдол
              шийдвэрлэх журам
            </strong>{" "}
            болон бусад холбогдох журам, Монгол Улсын холбогдох хууль
            тогтоомжоор зохицуулна.
          </p>
        ),
      },
      {
        text: "Уран бүтээлч болон MMusic-ын хооронд үйлчилгээтэй холбоотой маргаан гарвал юун түрүүнд харилцан зөвшилцөж шийдвэрлэхийг эрмэлзэх бөгөөд зөвшилцлийн аргаар шийдвэрлэж чадаагүй тохиолдолд маргааныг Монгол Улсын хуулийн дагуу Монгол Улсын харьяалах шүүхээр шийдвэрлүүлнэ.",
      },
    ],
  },
];

export const REGULAR_SECTION = [
  {
    title: "Энгийн буюу 60:40 орлого хуваалт",
    subTitle: "Таны дууг бид тусгай бус энгийн эрхтэйгээр Монголд борлуулна",
    badge: "MKaroake",
    percentage: "50%",

    content: [
      {
        list: (
          <>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Монголын зах зээлд таны Аудио уран бүтээл, Дууны дүрс бичлэг
                буюу клипийг цахимаар түгээх сувгуудад байршуулах, түүгээр
                дамжуулан түрээслүүлэх, борлуулах
              </li>
              <li>
                Аудио уран бүтээлийг цахимаар түгээх сувгуудад байршуулах,
                түүгээр дамжуулан нийтийн үйлчилгээний байгууллагуудад
                түрээслүүлэх, борлуулах
              </li>
              <li>
                Караоке болон ижил төстэй үйлчилгээгээр дамжуулан түрээслүүлэх
              </li>
              <li>
                Өргөн нэвтрүүлгийн Телевиз, радиогийн сувгуудад дуу, дууны дүрс
                бичлэг буюу клипийг түрээслүүлэх
              </li>
              <li>
                Синхрончлох эрх буюу уран бүтээлчийн аудио уран бүтээлийг кино,
                телевизийн нэвтрүүлэг, зар сурталчилгаа, видео тоглоом, дижитал
                медиа зэрэг дүрс, дуу хосолсон төслүүдэд ашиглах эрх (Борлуулалт
                нэмэлт гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Эрх олгогчийн лого, зураг, агуулга бүхий хэвлэмэл эх бүхий
                бүтээгдэхүүн үйлдвэрлэх эрх түрээслэх. (Борлуулалт нэмэлт
                гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Тоглолтыг жилд хамгийн багадаа 2 удаа борлуулан зуучлах эрх
                (Борлуулалт нэмэлт гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Таны сонсолтын орлого 10,000 төгрөгөөс давсан тохиолдолд сар
                бүрийн 25нд
              </li>
              <li>
                Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг давхар
                эзэмшдэг бол сонсолтын орлогын 60 хувийг, караокены орлогын 50
                хувийг
              </li>
              <li>
                Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг эзэмшдэггүй
                бол үйлчилгээний орлогын хувьд зохиогчийн эрхийн төлбөрийг
                суутгаж үйлчилгээнд хамаарах орлогын 50 хувийг олгоно. Караокены
                орлого 50 хувиар хуваагдана.
              </li>
            </ul>
            <p className="pt-6">
              Орлого хуваарилах дүнгийн доод хэмжээ 10 000 /нэг арван мянган/
              төгрөг байх бөгөөд сар бүрийн 25-ны өдрөөс хойш таны дансанд
              шилжинэ.
            </p>
          </>
        ),
      },
    ],
  },
];
export const SPECIAL_SECTION = [
  {
    title: "Онцгой буюу 70:30 орлого хуваалт",
    subTitle: "Таны дууг бид тусгай эрхтэйгээр Монголд борлуулна",
    badge: "MKaroake",
    percentage: "50%",

    content: [
      {
        list: (
          <>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Монголын зах зээлд таны Аудио уран бүтээл, Дууны дүрс бичлэг
                буюу клипийг цахимаар түгээх сувгуудад байршуулах, түүгээр
                дамжуулан түрээслүүлэх, борлуулах
              </li>
              <li>
                Аудио уран бүтээлийг цахимаар түгээх сувгуудад байршуулах,
                түүгээр дамжуулан нийтийн үйлчилгээний байгууллагуудад
                түрээслүүлэх, борлуулах
              </li>
              <li>
                Караоке болон ижил төстэй үйлчилгээгээр дамжуулан түрээслүүлэх
              </li>
              <li>
                Өргөн нэвтрүүлгийн Телевиз, радиогийн сувгуудад дуу, дууны дүрс
                бичлэг буюу клипийг түрээслүүлэх
              </li>
              <li>
                Синхрончлох эрх буюу уран бүтээлчийн аудио уран бүтээлийг кино,
                телевизийн нэвтрүүлэг, зар сурталчилгаа, видео тоглоом, дижитал
                медиа зэрэг дүрс, дуу хосолсон төслүүдэд ашиглах эрх (Борлуулалт
                нэмэлт гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Эрх олгогчийн лого, зураг, агуулга бүхий хэвлэмэл эх бүхий
                бүтээгдэхүүн үйлдвэрлэх эрх түрээслэх. (Борлуулалт нэмэлт
                гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Тоглолтыг жилд хамгийн багадаа 2 удаа борлуулан зуучлах эрх
                (Борлуулалт нэмэлт гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг давхар
                эзэмшдэг бол сонсолтын орлогын 70 хувийг, караокены орлогын 50
                хувийг
              </li>
              <li>
                Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг эзэмшдэггүй
                бол үйлчилгээний орлогын хувьд зохиогчийн эрхийн төлбөрийг
                суутгаж үйлчилгээнд хамаарах орлогын 50 хувийг олгоно. Караокены
                орлого 50 хувиар хуваагдана.
              </li>
            </ul>
            <p className="pt-6">
              Орлого хуваарилах дүнгийн доод хэмжээ 10 000 /нэг арван мянган/
              төгрөг байх бөгөөд сар бүрийн 25-ны өдрөөс хойш таны дансанд
              шилжинэ.
            </p>
          </>
        ),
      },
    ],
  },
];
export const GLOBAL_SECTION = [
  {
    title: "Онцгой буюу 70:30 орлого хуваалт мөн ОУ-ын түгээлт",
    subTitle:
      "Таны дууг бид тусгай эрхтэйгээр Монгол болон Олон Улсын зах зээлд борлуулна",
    badge: "MKaroake",
    percentage: "50%",
    global_badge: "GLobal",
    global_icon: "MetaIcon",

    content: [
      {
        list: (
          <>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                Монголын зах зээлд таны Аудио уран бүтээл, Дууны дүрс бичлэг
                буюу клипийг цахимаар түгээх сувгуудад байршуулах, түүгээр
                дамжуулан түрээслүүлэх, борлуулах
              </li>
              <li>
                Аудио уран бүтээлийг цахимаар түгээх сувгуудад байршуулах,
                түүгээр дамжуулан нийтийн үйлчилгээний байгууллагуудад
                түрээслүүлэх, борлуулах
              </li>
              <li>
                Караоке болон ижил төстэй үйлчилгээгээр дамжуулан түрээслүүлэх
              </li>
              <li>
                Өргөн нэвтрүүлгийн Телевиз, радиогийн сувгуудад дуу, дууны дүрс
                бичлэг буюу клипийг түрээслүүлэх
              </li>
              <li>
                Синхрончлох эрх буюу уран бүтээлчийн аудио уран бүтээлийг кино,
                телевизийн нэвтрүүлэг, зар сурталчилгаа, видео тоглоом, дижитал
                медиа зэрэг дүрс, дуу хосолсон төслүүдэд ашиглах эрх (Борлуулалт
                нэмэлт гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Эрх олгогчийн лого, зураг, агуулга бүхий хэвлэмэл эх бүхий
                бүтээгдэхүүн үйлдвэрлэх эрх түрээслэх. (Борлуулалт нэмэлт
                гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Тоглолтыг жилд хамгийн багадаа 2 удаа борлуулан зуучлах эрх
                (Борлуулалт нэмэлт гэрээгээр шийдэгдэнэ)
              </li>
              <li>
                Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг давхар
                эзэмшдэг бол сонсолтын орлогын 70 хувийг, караокены орлогын 50
                хувийг
              </li>
              <li>
                Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг эзэмшдэггүй
                бол үйлчилгээний орлогын хувьд зохиогчийн эрхийн төлбөрийг
                суутгаж үйлчилгээнд хамаарах орлогын 50 хувийг олгоно. Караокены
                орлого 50 хувиар хуваагдана.
              </li>
            </ul>
            <p className="pt-6">
              Орлого хуваарилах дүнгийн доод хэмжээ 10 000 /нэг арван мянган/
              төгрөг байх бөгөөд сар бүрийн 25-ны өдрөөс хойш таны дансанд
              шилжинэ.
            </p>
          </>
        ),
      },
    ],
  },
];
